// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__WJPuG","columnSkeleton":"styles_columnSkeleton__Io0e0"};